export const ID = 'e5b586ec-e359-4dce-8a6a-d4ea3b7e1dc9';

export const NAME = 'Social Media: Icons';

export const CONTEXT_MENU_MESSAGE = 'To edit social media icons, go to';
export const CONTEXT_MENU_LINK_TEXT = 'site branding';
